/** https://coolors.co/ef38b6-00d4ff-26547c-fdca40-06d6a0 */
export const colorPallete = {
    'green': '#06D6A0',
    'blue': '#00D4FF',
    'purple': '#EF38B6',
    'dark-blue': '#26547C',
    'yellow': '#FDCA40'
}